import { render } from "./GuideWindow.vue?vue&type=template&id=6d86a0a0"
import script from "./GuideWindow.vue?vue&type=script&lang=js"
export * from "./GuideWindow.vue?vue&type=script&lang=js"

import "./GuideWindow.vue?vue&type=style&index=0&id=6d86a0a0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__